import React, { Component } from "react";
import { withRouter } from "react-router";
import addAccessTokenToUrl from "../../../Utils/Axios/addTokenToUrl";
import axios from "axios";
import Rendermodals from "../../Modals/modal";
import { SIDE_NAV_ITEMS } from "../../../api-constant";
import CreateProfile from "./CreateProfile";
import NavBar from "../../NavBar/Navbar";
import Sidebar from "../../Sidebar/sidebar";
import ResponsiveSidebar from "../../Sidebar/Responsive/SideBar";
import { history } from '../../../../_helpers';



export class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      fieldValidation: false,
      assessmentModal: true,
      enableNotification: false,
      namevalue: "",
      shortNamevalue: "",
      nameinvalid: false,
      shortNameinvalid: false,
    };
  }
  

  handleEnableField = () => {
    this.setState({
      fieldsEnabled: true,
      buttons: true,
    });
  };

  handleFieldValidation = (e) => {
    e.preventDefault();
    this.setState({
      fieldValidation: true,
    });
  };

  handleModalClose = () => {
    this.setState({
      assessmentModal: false,
    });
  };

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };

  handleNameChange = (e) => {
    this.setState({
      namevalue: e.target.value,
      nameinvalid: false,
    });
  };

  handleShortNameChange = (e) => {
    this.setState({
      shortNamevalue: e.target.value,
      shortNameinvalid: false,
    });
  };

  handleReset = () => {
    this.setState({
      shortNamevalue: "",
      namevalue: "",
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.namevalue == "" && this.state.shortNamevalue == "") {
      this.setState({
        shortNameinvalid: true,
        nameinvalid: true,
      });
    }
    if (this.state.shortNamevalue == "") {
      this.setState({
        shortNameinvalid: true,
        nameinvalid: false,
      });
    }
    if (this.state.namevalue == "") {
      this.setState({
        nameinvalid: true,
      });
    }
    if (
      this.state.namevalue.length > 0 &&
      this.state.shortNamevalue.length > 0
    ) {
      this.setState({
        shortNameinvalid: false,
        nameinvalid: false,
      });
      // create profile post data
      axios
        .post(addAccessTokenToUrl("/users/user/profile/updatenew/"), {
          full_name: this.state.namevalue,
          short_name: this.state.shortNamevalue,
        })
        .then((response) => {
          localStorage.setItem("full_name", this.state.namevalue);
          localStorage.setItem("user_name", this.state.namevalue);
          localStorage.setItem("new_user", true);
          localStorage.setItem("short_name", this.state.shortNamevalue);
          const isAuthParticipant = localStorage.getItem("is_auth_participant");

          if(isAuthParticipant==='false'){
            this.props.history.push({
              pathname: `/new/app/editprofile`,
            });
          }else{
            const id = localStorage.getItem('assessment_id');
            const seller = localStorage.getItem('seller');
            const organisation = localStorage.getItem('organisation');
            const participant__id = localStorage.getItem('participant__id');
            const instrument__is_multi_rater = localStorage.getItem('instrument__is_multi_rater');
            const assessment_completed_count = localStorage.getItem('assessment_completed_count');
            this.props.history.push(`/new/app/questionnaire/9/${id}/${organisation}/${seller}/${participant__id}/${instrument__is_multi_rater}/${assessment_completed_count}/assessment`);
          }
        
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  handleCloseNotification = () => {
    this.setState({
      enableNotification: false
    })
  }

  render() {
        const fullName = localStorage.getItem("full_name");
    const shortName = localStorage.getItem("short_name");
    const isAuthParticipant = localStorage.getItem("is_auth_participant");
    const assessment_done = localStorage.getItem("assessment_done");
 
    if ( isAuthParticipant==='true' && assessment_done==='true' &&
    (fullName !== "null" || fullName !== ""|| fullName !== null) &&
    (shortName !== "null" || shortName !== "" ||shortName !== null)
  ) {
    
    history.push('/assessment-expired');
  }


    return (
      <div>
        <NavBar
          enableNotification={this.state.enableNotification}
          handleNotification={this.handleNotification}
          handleCloseNotification={this.handleCloseNotification}
        />
        <ResponsiveSidebar
          items={SIDE_NAV_ITEMS}
          selectedSideNav={this.state.selectedSideNav}
          sidebarOpen={this.state.sidebarOpen}
          onSetSidebarOpen={this.onSetSidebarOpen}
        />
        <Sidebar items={SIDE_NAV_ITEMS} />
        <Rendermodals
          assessmentModal={this.state.assessmentModal}
          handleModalClose={this.handleModalClose}
          modalHeading="Create Profile"
        >
          <CreateProfile
            handleReset={this.handleReset}
            handleSubmit={this.handleSubmit}
            handleFieldValidation={this.handleFieldValidation}
            nameinvalid={this.state.nameinvalid}
            shortNameinvalid={this.state.shortNameinvalid}
            handleNameChange={this.handleNameChange}
            handleShortNameChange={this.handleShortNameChange}
            namevalue={this.state.namevalue}
            shortNamevalue={this.state.shortNamevalue}
          />
        </Rendermodals>
      </div>
    );
  }
}

export default withRouter(Create);



// WEBPACK FOOTER //
// ./src/new/Components/View-Or-Edit-profile/CreateProfile/index.jsx